"use client";
import t, { forwardRef as x, useState as b, useMemo as S } from "react";
import { defaultCountries as V, parseCountry as D, usePhoneInput as N, FlagImage as g } from "react-international-phone";
import { Combobox as m, Portal as $ } from "@ark-ui/react";
import { Phone as k } from "lucide-react";
import { phoneInput as y } from "@huspy/styled-system/recipes";
import { Flex as w } from "../box/index.mjs";
import { Input as v } from "../input/input.mjs";
import "../input/input-group.mjs";
const E = V.map((n) => {
  const r = D(n);
  return {
    ...r,
    label: r.name,
    value: r.iso2
  };
}), R = (n) => {
  const {
    inputHook: { country: r },
    onCountryChange: p,
    disabled: o
  } = n, [s] = y.splitVariantProps(n), u = y(s), [l, C] = b(null), d = S(
    () => l != null && l.length ? E.filter((e) => e.dialCode.includes(l)) : E,
    [l]
  ), h = (e) => {
    if (!e) return;
    const a = e.replace("+", ""), i = d.find((f) => f.dialCode === a);
    i && p(i), C(a);
  }, c = (e) => {
    var i;
    const a = (i = e.items) == null ? void 0 : i[0];
    a != null && a.iso2 && (C(null), p(a));
  };
  return /* @__PURE__ */ t.createElement(m.Root, { items: d, onValueChange: c }, /* @__PURE__ */ t.createElement(m.Control, null, /* @__PURE__ */ t.createElement(m.Context, null, (e) => /* @__PURE__ */ t.createElement(
    v,
    {
      icon: /* @__PURE__ */ t.createElement(g, { iso2: r.iso2, className: u.flagSelector, width: "1rem" }),
      iconPosition: "left",
      _active: { borderColor: "neutral.50" },
      maxW: "6.5rem",
      w: "max-content",
      textAlign: "left",
      size: "md",
      maxLength: 5,
      flex: 1,
      value: `+${l ?? r.dialCode}`,
      onChange: (a) => h(a.target.value),
      onFocus: () => !e.open && e.setOpen(!0),
      onClick: () => !e.open && e.setOpen(!0),
      onKeyDown: () => !e.open && e.setOpen(!0),
      disabled: o
    }
  ))), /* @__PURE__ */ t.createElement($, null, /* @__PURE__ */ t.createElement(m.Positioner, { className: u.positioner }, /* @__PURE__ */ t.createElement(m.Content, { className: u.menuContent }, d.map((e) => /* @__PURE__ */ t.createElement(m.Item, { key: e.value, item: e, className: u.menuItem }, /* @__PURE__ */ t.createElement(g, { iso2: e.iso2, className: u.flagSelector }), /* @__PURE__ */ t.createElement(m.ItemText, null, e.name, " +", e.dialCode), /* @__PURE__ */ t.createElement(m.ItemIndicator, null, "✓")))))));
}, F = (n) => {
  const {
    defaultCountry: r,
    value: p,
    countries: o,
    preferredCountries: s,
    prefix: u,
    defaultMask: l,
    charAfterDialCode: C,
    historySaveDebounceMS: d,
    disableCountryGuess: h,
    disableDialCodeAndPrefix: c,
    disableDialCodePrefill: e,
    forceDialCode: a,
    disableFormatting: i,
    inputRef: f,
    // removing default onChange
    ...P
  } = n;
  return {
    inputProps: P,
    phoneInputProps: {
      defaultCountry: r,
      value: p,
      countries: o,
      preferredCountries: s,
      prefix: u,
      defaultMask: l,
      charAfterDialCode: C,
      historySaveDebounceMS: d,
      disableCountryGuess: h,
      disableDialCodeAndPrefix: c,
      disableDialCodePrefill: e,
      forceDialCode: a,
      disableFormatting: i,
      inputRef: f
    }
  };
}, I = (n, r) => n && n.replace(`+${r}`, "").trim(), K = x(
  (n, r) => {
    const { phoneInputProps: p, inputProps: o } = F(n), s = N(p), u = n.value ? I(n.value, s.country.dialCode) : "", [l, C] = b(u), d = (c) => {
      o != null && o.onChange && o.onChange({
        phone: `+${c.dialCode}${l}`,
        country: c,
        inputValue: l
      }), s.setCountry(c.iso2);
    }, h = (c) => {
      var i;
      const e = (i = c.target.value) == null ? void 0 : i.replace(/\D/g, ""), a = {
        phone: `+${s.country.dialCode}${e}`,
        country: s.country,
        inputValue: e
      };
      C(I(e, a.country.dialCode)), o != null && o.onChange && o.onChange(a);
    };
    return /* @__PURE__ */ t.createElement(w, { gap: "1" }, /* @__PURE__ */ t.createElement(
      R,
      {
        inputHook: s,
        onCountryChange: d,
        disabled: o.disabled
      }
    ), /* @__PURE__ */ t.createElement(
      v,
      {
        ...o,
        value: l,
        onChange: h,
        icon: /* @__PURE__ */ t.createElement(k, { width: "14px", height: "14px", color: "#4B5563" }),
        iconPosition: "right",
        ref: r
      }
    ));
  }
);
export {
  K as PhoneNumberInput
};
